<div class="container portfolio-shell">
  <div class="section-header">
    <p class="eyebrow">Our Diverse Portfolio</p>
    <h2>Our success across various sectors demonstrates our ability to scale any high-potential business</h2>
  </div>

  <div class="project-list">
    <a *ngFor="let project of projects" [attr.href]="'https://' + project.domain" target="_blank" rel="noopener noreferrer" class="project-row-link">
      <article class="project-row">
        <div class="project-icon" aria-hidden="true">
          <span class="project-icon-ring"></span>
        </div>

        <h3>{{ project.title }}</h3>

        <p class="project-summary">
          {{ project.description }} <br> {{ project.detail }}
        </p>

        <span class="project-arrow" aria-hidden="true">↗</span>
      </article>
    </a>
  </div>
</div>
